if (!customElements.get('collection-infinite-scroll')) {
  class CollectionInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.nextUrl = this.getAttribute('next-url') || '';
      this.sectionId = this.getAttribute('section-id') || '';
      this.productListId = this.getAttribute('product-list-id') || '';
      this.statusElement = this.querySelector('.collection-infinite-scroll__status');
      this.sentinel = this.querySelector('.collection-infinite-scroll__sentinel');
      this.loading = false;

      if (!this.nextUrl || !this.sentinel || !this.sectionId || !this.productListId) {
        this.remove();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
        },
        { rootMargin: '800px 0px' }
      );

      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }

    findById(root, id) {
      if (!root || !id) return null;
      return root.querySelector(`[id="${String(id).replace(/"/g, '\\"')}"]`);
    }

    async loadNextPage() {
      if (this.loading || !this.nextUrl) return;

      this.loading = true;
      if (this.statusElement) this.statusElement.textContent = 'Ürünler yükleniyor…';
      this.abortController = new AbortController();

      try {
        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);

        const response = await fetch(url.toString(), {
          signal: this.abortController.signal,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'text/html'
          }
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');

        // Shopify Section Rendering API yalnızca bölüm içeriğini döndürebilir;
        // tam sayfa dönerse de aynı seçiciler çalışmaya devam eder.
        const newProductList = this.findById(parsedDocument, this.productListId);
        const currentProductList = document.getElementById(this.productListId);
        const newLoader = parsedDocument.querySelector('collection-infinite-scroll');

        if (!newProductList || !currentProductList) {
          throw new Error('Yeni ürün listesi bulunamadı.');
        }

        const newChildren = Array.from(newProductList.children);

        newChildren.forEach((child) => {
          const importedChild = document.importNode(child, true);

          // Tema ilk yüklemede ürünleri animasyonla görünür yapıyor. Sonradan eklenen
          // kartlarda bu observer yeniden kurulmadığı için kartlar opacity:0 kalabiliyor.
          if (importedChild.matches?.('product-card[reveal-on-scroll="true"]')) {
            importedChild.removeAttribute('reveal-on-scroll');
            importedChild.style.opacity = '1';
            importedChild.style.transform = 'none';
          }

          importedChild.querySelectorAll?.('product-card[reveal-on-scroll="true"]').forEach((card) => {
            card.removeAttribute('reveal-on-scroll');
            card.style.opacity = '1';
            card.style.transform = 'none';
          });

          currentProductList.appendChild(importedChild);
        });

        this.nextUrl = newLoader?.getAttribute('next-url') || '';

        if (this.nextUrl) {
          this.setAttribute('next-url', this.nextUrl);
          if (this.statusElement) this.statusElement.textContent = '';
          this.loading = false;

          // Sayfa tamamen tükenmiş ürünlerden oluşuyorsa görünür kart eklenmeyebilir.
          // Bu durumda kullanıcıyı boş bir yükleme alanında bırakmadan sonraki sayfaya geç.
          if (newChildren.length === 0 || this.sentinel.getBoundingClientRect().top < window.innerHeight + 800) {
            window.requestAnimationFrame(() => this.loadNextPage());
          }
        } else {
          this.observer?.disconnect();
          if (this.statusElement) this.statusElement.textContent = '';
          this.removeAttribute('next-url');
          this.loading = false;
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('[Collection infinite scroll]', error);
        if (this.statusElement) this.statusElement.textContent = 'Ürünler yüklenemedi. Sayfayı yenileyin.';
        this.observer?.disconnect();
        this.loading = false;
      }
    }
  }

  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
}
